import { createContext, useEffect, useState } from 'react';

// Создание контекста для управления состоянием загрузки скрипта
const CloudinaryScriptContext = createContext();

function UploadWidget({ uwConfig, setState }) {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    // Проверка, загружен ли скрипт
    if (!loaded) {
      const uwScript = document.getElementById('uw');
      if (!uwScript) {
        // Если скрипт не загружен, создаем и загружаем его
        const script = document.createElement('script');
        script.setAttribute('async', '');
        script.setAttribute('id', 'uw');
        script.src = 'https://upload-widget.cloudinary.com/global/all.js';
        script.addEventListener('load', () => setLoaded(true));
        document.body.appendChild(script);
      } else {
        // Если скрипт уже загружен, обновляем состояние
        setLoaded(true);
      }
    }
  }, [loaded]);

  const initializeCloudinaryWidget = () => {
    if (loaded) {
      var myWidget = window.cloudinary.createUploadWidget(
        {
          ...uwConfig,
          uploadPreset: 'foxads',
          transformations: [
            {
              width: 500,
              quality: 'auto',
              fetch_format: 'webp', // Конвертируем в webp
            },
          ],
        },
        (error, result) => {
          if (!error && result && result.event === 'success') {
            console.log(
              'Upload complete!'
            );
            setState((prev) => [
              ...prev,
              { url: result.info.secure_url, public_id: result.info.public_id },
            ]);
          }
        }
      );

      document.getElementById('upload_widget').addEventListener(
        'click',
        function () {
          myWidget.open();
        },
        false
      );
    }
  };

  return (
    <CloudinaryScriptContext.Provider value={{ loaded }}>
      <button
        id="upload_widget"
        className="cloudinary-button"
        onClick={initializeCloudinaryWidget}
      >
        Upload
      </button>
    </CloudinaryScriptContext.Provider>
  );
}

export default UploadWidget;
export { CloudinaryScriptContext };
